import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';

import Button from '../../components/common/button';

import { isAllFieldsValid } from '../../helpers/validationHelper';

import {
  registerPaths,
  registerValidationModels,
  getOrganizationTaxIdValidationModel
} from './constants';

class SaveButtonContainer extends Component {
  isAllFieldsValid = () => {
    const fieldsWithValidationModels = Object.keys(
      registerValidationModels
    ).map((item) => {
      // The tax ID model depends on the selected country, so build it
      // dynamically here to keep the save-button gate in sync with the field.
      const validationModel =
        item === 'organizationTaxId'
          ? getOrganizationTaxIdValidationModel(
              get(this.props.model, registerPaths.organizationCountry)
            )
          : registerValidationModels[item];

      return {
        validationModel,
        value: get(this.props.model, validationModel.path)
      };
    });

    return isAllFieldsValid(fieldsWithValidationModels);
  };

  render() {
    return (
      <Button
        primary
        loading={this.props.isLoading}
        disabled={!this.isAllFieldsValid()}
        onClick={() => this.props.handleSave(this.props.model)}
        type="button"
      >
        <Translate value="template.register.save-button" />
      </Button>
    );
  }
}

const mapState = ({ templateBuilderEx }) => {
  return {
    model: templateBuilderEx.data
  };
};

const SaveButton = connect(mapState)(SaveButtonContainer);
export default SaveButton;
